export const GET_PAYMENTMETHOD = "GET_PAYMENTMETHOD";
export const CREATE_PAYMENT_METHOD = "CREATE_PAYMENT_METHOD";
export const EDIT_PAYMENT_METHOD = "EDIT_PAYMENT_METHOD";
export const DELETE_PAYMENT_METHOD = "DELETE_PAYMENT_METHOD";
export const OPEN_PAYMENT_METHOD_DIALOG = "OPEN_PAYMENT_METHOD_DIALOG";
export const CLOSE_PAYMENT_METHOD_DIALOG = "CLOSE_PAYMENT_METHOD_DIALOG";